import axios from 'axios';

export default {
    fetchAllProductionTimesForRange(startDate, endDate) {
        return axios.post('/employee/fetchAllProductionTimesForRange/', {
            startDate,
            endDate,
        });
    },
    listAllTimeRegistrations(payload) {
        return axios.post('/employee/listAllTimeRegistrations/', payload);
    },
    fetchAllLeaveForYear(employeeId, year) {
        return axios.post('/employee/fetchAllLeaveForYear/', {
            forEmployeeId: employeeId,
            year,
        });
    },
    fetchAbsenceForYear(employeeId, year) {
        return axios.post('/employee/fetchAbsenceForYear/', {
            forEmployeeId: employeeId,
            year,
        });
    },
    printQrCode(employeeId, preferredPrinter) {
        return axios.post('/employee/printQrCode/', {
            id: employeeId,
            preferredPrinter,
        });
    },
    updateAbsence(id, date, reason, employeeId) {
        return axios.post('/employee/updateAbsence/', {
            id,
            date,
            reason,
            forEmployeeId: employeeId,
        });
    },
    addForgottenDay(date, employeeId) {
        return axios.post('/employee/addForgottenDay/', {
            date,
            forEmployeeId: employeeId,
        });
    },
    deleteAbsence(id) {
        return axios.post('/employee/deleteAbsence/', { id });
    },
    addAbsence(date, dateEnd, reason, employeeId) {
        return axios.post('/employee/addAbsence/', {
            date,
            dateEnd,
            reason,
            forEmployeeId: employeeId,
        });
    },
    updateLeave(id, date, startTime, endTime, employeeId) {
        return axios.post('/employee/updateLeave/', {
            id,
            date,
            startTime,
            endTime,
            forEmployeeId: employeeId,
        });
    },
    addLeave(date, dateEnd, startTime, endTime, employeeId) {
        return axios.post('/employee/addLeave/', {
            date,
            dateEnd,
            startTime,
            endTime,
            forEmployeeId: employeeId,
        });
    },
    deleteLeave(id) {
        return axios.post('/employee/deleteLeave/', {
            id,
        });
    },
    fetchLeaveForYear(year, employeeId) {
        return axios.post('/employee/fetchLeaveForYear/', {
            year,
            forEmployeeId: employeeId,
        });
    },
    fetchAbsencesForRange(startDate, endDate) {
        return axios.post('/employee/fetchAbsencesForRange/', {
            startDate,
            endDate,
        });
    },
    fetchAllLeaveForRange(startDate, endDate) {
        return axios.post('/employee/fetchAllLeaveForRange/', {
            startDate,
            endDate,
        });
    },
    fetchAllAbsencesAndPresencesForDay(date) {
        return axios.post('/employee/fetchAllAbsencesAndPresencesForDay/', {
            date,
        });
    },
    updateCapacityCalculationForEmployee(employeeId, capacityCalculation) {
        return axios.post('/employee/updateCapacityCalculationForEmployee/', {
            forEmployeeId: employeeId,
            capacityCalculation,
        });
    },
    updateActiveForEmployee(employeeId, active) {
        return axios.post('/employee/updateActiveForEmployee/', {
            forEmployeeId: employeeId,
            active,
        });
    },
    updateWorktime(employeeId, day, worktime, type) {
        return axios.post('/employee/updateWorktime/', {
            forEmployeeId: employeeId,
            day,
            worktime,
            type,
        });
    },
    fetchImportWorkdayColumns() {
        return axios.post('/employee/importWorkdayColumns/');
    },
    importWorkday(lines) {
        return axios.post('/employee/importWorkday/', { lines });
    },
    listTimeregistrations() {
        return axios.post('/employee/listTimeregistrations/');
    },
    listBreaks() {
        return axios.post('/employee/listBreaks/');
    },
    listBreaksAndTimeregistrations() {
        return axios.post('/employee/listBreaksAndTimeregistrations/');
    },
    registerTimeLocation(location, employeeId) {
        return axios.post('/employee/registerTimeLocation/', {
            location,
            employee: employeeId,
        });
    },
    countTimeregistrations(location, employeeId) {
        return axios.post('/employee/countTimeregistrations/', {
            employeeId,
            location,
        });
    },
    registerTime(location, employeeId) {
        return axios.post('/employee/registerTime/', { employeeId, location });
    },
    registerBreak() {
        return axios.post('/employee/registerBreak/');
    },
    registerTimePause(pause) {
        return axios.post('/employee/registerTimePause/', { pause });
    },
};
